import { addDays, format } from "date-fns";
import { rangeConflict } from "@/lib/availability";

const iso = (d) => format(d, "yyyy-MM-dd");

/** Mindestaufenthalt für den Anreisetag – wie Backend _min_nights: Saisonwert, sonst Objektwert, sonst Standard aus den Einstellungen. */
export const minNightsFor = (prop, settings, day) => {
  const base = Number(prop?.min_nights) || Number(settings?.default_min_nights) || 1;
  if (!day) return base;
  const d = iso(day);
  const s = (prop?.seasons || []).find((x) => d >= x.start_date && d <= x.end_date);
  return (s && Number(s.min_nights)) || base;
};

/** Anreise in einer Lücke mit Lücken-Angebot → kürzer erlaubt, Kalender sperrt nichts. */
export const inGap = (gaps, day) => { if (!day || !gaps?.length) return false; const d = iso(day); return gaps.some((g) => d >= g.start && d <= g.end); };

/** Matcher für Tage nach der Anreise, die als Abreise zu kurz wären. */
export const tooShortMatcher = (prop, settings, from, gaps) => {
  if (!from || inGap(gaps, from)) return () => false;
  const a = iso(from), b = iso(addDays(from, minNightsFor(prop, settings, from)));
  return (d) => { const x = iso(d); return x > a && x < b; };
};

/** Frühestes Abreisedatum für `min` Nächte – null, wenn bis dahin eine Belegung liegt. */
export const earliestCheckout = (from, min, availability) => {
  if (!from || !min) return null;
  const to = addDays(from, min);
  return rangeConflict(availability, from, to) ? null : to;
};
